import { AnyAction } from 'redux'
import { ACTIONS } from './constants'
import { APP_MESSAGE_TYPE } from '@/types/appMessage'
import { AppMessageAction } from './types'

export const showError = (text: string): AppMessageAction => ({
  type: ACTIONS.APP_MESSAGE_SHOW,
  payload: {
    style: 'error',
    text,
  },
})

export const showSuccess = (text: string): AppMessageAction => ({
  type: ACTIONS.APP_MESSAGE_SHOW,
  payload: {
    style: 'positive',
    text,
  },
})

export const showMessage = (
  text: string,
  feedback: APP_MESSAGE_TYPE
): AnyAction => ({
  type: ACTIONS.APP_MESSAGE_SHOW,
  payload: {
    style: feedback,
    text,
  },
})

export const reset = (): AnyAction => ({
  type: ACTIONS.APP_MESSAGE_RESET,
})
